import { render, staticRenderFns } from "./viewProperty.vue?vue&type=template&id=82f45a6e&"
import script from "./viewProperty.vue?vue&type=script&lang=js&"
export * from "./viewProperty.vue?vue&type=script&lang=js&"
import style0 from "./viewProperty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VForm,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82f45a6e')) {
      api.createRecord('82f45a6e', component.options)
    } else {
      api.reload('82f45a6e', component.options)
    }
    module.hot.accept("./viewProperty.vue?vue&type=template&id=82f45a6e&", function () {
      api.rerender('82f45a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Shift/ShiftList/components/viewProperty.vue"
export default component.exports